// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__217aB","type":"styles_type__3Qzvf","choices":"styles_choices__36FbM"};